import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseCookies(): Record<string, string> {
  return document.cookie
    .split("; ")
    .reduce((cookies: Record<string, string>, cookie) => {
      const [name, ...valueParts] = cookie.split("=");
      const value = valueParts.join("=");
      cookies[decodeURIComponent(name?.trim() || "")] = decodeURIComponent(
        value.trim(),
      );
      return cookies;
    }, {});
}

export const drop = (arr: Array<any>, n = 1) => arr.slice(n);
